import { render } from "./DeleteEventModal.vue?vue&type=template&id=12a6328b&scoped=true&ts=true"
import script from "./DeleteEventModal.vue?vue&type=script&lang=ts"
export * from "./DeleteEventModal.vue?vue&type=script&lang=ts"

import "./DeleteEventModal.vue?vue&type=style&index=0&id=12a6328b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a6328b"]])

export default __exports__